module.exports = __webpack_public_path__ + "img/bg1.23b387f3.jpg";